import A11yDialog from 'a11y-dialog';
import Tabby from 'tabbyjs';
import { toggleDialogState } from '../../../js/utils';
import CountryNavLanguageAccordion from '../country-nav-accordion-language/country-nav-accordion-language';
import ContentAccordion from "../accordion-new/accordion-new";

export default class CountryNavDialog {
  constructor(
    dialogCountry = 'swa-header-country-nav-dialog',
    activeClass = 'swa-tab-accordion-country-is-active',
    hiddenClass = 'swa-tab-accordion-country-is-hidden',
    initializedClass = 'swa-tab-accordion-country-initialized',
    headerDataAttr = 'data-swa-tab-accordion-country-id'
  ) {
    this.dialogCountry = dialogCountry;
    this.countryDialogElement = document.querySelector(`#${this.dialogCountry}`);
    this.activeClass = activeClass;
    this.hiddenClass = hiddenClass;
    this.initializedClass = initializedClass;
    this.headerDataAttr = headerDataAttr;
  }

  init() {
    const styleOverlay = { open: 'swa-dialog-open'};

    if (!this.countryDialogElement) {
      return;
    }

    window.globalCountryDialogInst = this.countryDialogElement
      ? new A11yDialog(this.countryDialogElement)
      : null;

    window.swaContentAccordion = ContentAccordion;
    const contentAccordionObj = new ContentAccordion('.js-swa-content-accordion');
    contentAccordionObj.init();

    if (this.countryDialogElement.querySelector('[data-tabs]')) {
      window.globalCountrySelectorTabs = new Tabby('[data-tabs]');
    } else {
      window.globalCountrySelectorTabs = null;
    }

    // toogle dialog style and instantiate the accordion when dialog gets shown
    globalCountryDialogInst.on('show', () => {
      document.querySelector('body').classList.add('swa-no-scroll');
      toggleDialogState(`#${this.dialogCountry}`, true);
      this.countryDialogElement.classList.toggle(styleOverlay.open);

      if (globalCountrySelectorTabs) {
        // set default activeTab for country dialog
        let activeTab = document.querySelectorAll('.js-swa-country-tab-link');
        globalCountrySelectorTabs.toggle(activeTab[0].getAttribute('href'));
      }
    });

    // CountryNavLanguageAccordion initialized
    const countryLanguageAccordion = new CountryNavLanguageAccordion();
    countryLanguageAccordion.init();

    globalCountryDialogInst.on('hide', () => {
      toggleDialogState(`#${this.dialogCountry}`, false);
      this.countryDialogElement.classList.toggle(styleOverlay.open);
      contentAccordionObj.init();
      document.querySelector('body').classList.remove('swa-no-scroll');
    });
  }
}
